import { render, staticRenderFns } from "./QuestionContact.vue?vue&type=template&id=1a9007de"
import script from "./QuestionContact.vue?vue&type=script&lang=js"
export * from "./QuestionContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports